import { NgModule } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import {FileUploadModule} from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';

@NgModule({
    imports: [
        ToolbarModule,
        ButtonModule,
        SplitButtonModule,
        MenuModule,
        CardModule,
        PanelModule,
        InputTextModule,
        PasswordModule,
        TableModule,
        MultiSelectModule,
        DropdownModule,
        MessageModule,
        MessagesModule,
        DialogModule,
        FileUploadModule,
        ToastModule,
        ConfirmDialogModule
    ],
    exports: [
        ToolbarModule,
        ButtonModule,
        SplitButtonModule,
        MenuModule,
        CardModule,
        PanelModule,
        InputTextModule,
        PasswordModule,
        TableModule,
        MultiSelectModule,
        DropdownModule,
        MessageModule,
        MessagesModule,
        DialogModule,
        FileUploadModule,
        ToastModule,
        ConfirmDialogModule
    ],
    providers: [MessageService,ConfirmationService]
})
export class PrimeNGModule { }